import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/video-diagnostic/Hello.png'


const _withScopeId = n => (_pushScopeId("data-v-424cda47"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row-span-2 text-sm sm:text-base lg:text-sm xl:text-base pt-10 lg:pt-20" }
const _hoisted_2 = { class: "font-bold text-xl sm:text-4xl lg:text-xl xl:text-4xl" }
const _hoisted_3 = { class: "py-4 sm:py-10" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-sm sm:text-base lg:text-sm xl:text-base row-span-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-72 h-72 m-auto" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: ""
    })
  ])
], -1))

import DiagnosticSection from '@/components/video-diagnostic/DiagnosticSection.vue'
import { Stage } from '@/types/enums/zoom-diagnostic.enum'

interface GetStartedEmits {
  (e: 'nextStage', value: number): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GetStarted',
  props: {
  stage: {
    type: Number,
    required: true,
  },
},
  emits: ["nextStage"],
  setup(__props, { emit: __emit }) {



const emit = __emit

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DiagnosticSection, {
    id: _unref(Stage).GET_STARTED,
    class: _normalizeClass(
      __props.stage === _unref(Stage).GET_STARTED || __props.stage === _unref(Stage).RESULTS
        ? 'block'
        : 'hidden md:block opacity-30 pointer-events-none'
    )
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('zoom-diagnostic.get-start-title')), 1),
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('zoom-diagnostic.start-detail')), 1),
        _createElementVNode("button", {
          class: _normalizeClass([{ 'opacity-30 pointer-events-none': __props.stage === _unref(Stage).RESULTS }, "text-white border-2 rounded-md border-white py-2 px-4"]),
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('nextStage', _unref(Stage).CHECK_PERMISSIONS)))
        }, _toDisplayString(_ctx.$t('zoom-diagnostic.get-start')), 3)
      ]),
      _hoisted_4
    ]),
    _: 1
  }, 8, ["id", "class"]))
}
}

})